export LayoutRoute from './layout';
export ShowRoute from './show/show';
export InsightsRoute from './insights/insights';



// WEBPACK FOOTER //
// ./src/routes/project/index.js